import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeUsesState } from '../selectors';

export const getData = createSelector(selectHomeUsesState, (state: State) => state.data);

export const getError = createSelector(selectHomeUsesState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeUsesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectHomeUsesState, (state: State) => fn(state.data));
